module.exports = __webpack_public_path__ + "assets/f6475e7ae1f58f277137127ec6cdfdfb.svg";